import type { InvoiceUserInvoiceTablePlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { nothing } from 'lit';

export const defaultInvoiceUserInvoicesTablePlugin: InvoiceUserInvoiceTablePlugin = {
  id: 'invoice-user-invoice-table::default',
  type: 'invoice-user-invoice-table',
  render: (
    host: ChemistryLitElement,
    translation: TranslationController<BHTranslationDictionary>,
    userID: string,
    institutionID: string,
  ) => nothing,
};
